import jwt_decode from 'jwt-decode';

import { JsonTokenDecoded } from '~/types/JsonTokenDecoded';

export const getEmailFromAccessToken = (accessToken: string) => {
  const decoded: JsonTokenDecoded = jwt_decode(accessToken);

  return decoded.email;
};
